class SearchTrigger extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this._handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this._handleClick);
  }

  _handleClick() {
    // document.dispatchEvent(new CustomEvent("load_search"));
    // move to the back
    this.querySelector(".search-bar__top-wrapper").style.zIndex = "-1";
    this.querySelector('[data-component="SearchBar"] input')?.focus();
  }
}

customElements.define("search-trigger", SearchTrigger);
